import { Divider } from '@chakra-ui/react';
import Script from 'next/script';
import React from 'react';

import { Footer } from '@/layout';
import { PageLayout } from '@/layouts';
import { t } from '@/utils';
import { ContactSection, LocationSection } from '@/views/contact/sections';

const ContactPage = () => (
  <PageLayout
    nextPageHref={null}
    seoProps={{
      title: t(`pages.home.seo.title`),
      description: t(`pages.home.seo.description`),
    }}
    // showFloatingButtons
  >
    <LocationSection />
    <ContactSection />
    <Divider />
    <Footer />

    {/* <!-- Google tag (gtag.js) --> */}
    <Script src="https://www.googletagmanager.com/gtag/js?id=AW-11334151501" />
    <Script id="google-analytics">
      {`
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());

        gtag('config', 'AW-11334151501');
      `}
    </Script>

    {/* eslint-disable-next-line @next/next/no-sync-scripts */}
    <script
      type="text/javascript"
      async={false}
      // strategy="lazyOnload"
      src="//wcs.naver.net/wcslog.js"
      // eslint-disable-next-line react/no-unknown-property
      charSet="UTF-8"
      onLoad={(e) => {
        // `
        //   console.log('Scripted loaded (1): ', ${e});
        // `
        console.log(`TEST 132`);
      }}
      onError={(e) => {
        console.error(`Script failed to load`, e);
      }}
    />
    {/* <script type="text/javascript" src="//wcs.naver.net/wcslog.js"></script> */}

    <script
      type="text/javascript"
      dangerouslySetInnerHTML={{
        __html: `
          var _nasa = {};
          if (window.wcs) _nasa["cnv"] = wcs.cnv("5","10"); // 전환유형, 전환가치 설정해야함. 설치매뉴얼 참고
        `,
      }}
    />
  </PageLayout>
);

export default ContactPage;
